import { Checkbox, Divider } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { UpOutlined } from '@ant-design/icons';
import { Filter } from '@common/models';

interface FilterItemProps {
    headline: string;
    filter: Filter;
    handleFilterSection: (key: string) => void;
    selectFilter: (e: CheckboxChangeEvent) => void;
}

const FilterItem = ({ headline, filter, selectFilter, handleFilterSection }: FilterItemProps) => {
    const sortedFilterOptions = [...filter.filterOptions].sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
        }
        return 0;
    });
    return (
        <>
            <div className="section-headline">
                {headline as string}
                <div className="expand-collapse-arrow" onClick={() => handleFilterSection(headline)}>
                    {!filter.isExpanded ? <UpOutlined rotate={180} /> : <UpOutlined />}
                </div>
            </div>
            {filter.isExpanded && (
                <>
                    <Divider />
                    <div className="filter-options">
                        {sortedFilterOptions.map((filterOption, index) => (
                            <Checkbox
                                key={index}
                                value={filterOption.name}
                                onChange={selectFilter}
                                checked={filterOption.isSelected}
                                className={`${filterOption.numberOfItems === 0 ? 'hide' : ''}`}
                            >
                                {filterOption.name}
                                <div className="counts">{`(${filterOption.numberOfItems})`}</div>
                            </Checkbox>
                        ))}
                    </div>
                </>
            )}
        </>
    );
};

export default FilterItem;
